import React from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useGetGiftQuery } from '../../../redux/api/authorized/gifts';
import { selectPrivyToken } from '../../../redux/slices/auth';
import WidthContainer from '../../../components/WidthContainer';
import styled from 'styled-components';
import GiftSkeleton from './ClaimGiftSkeleton';
import SendingStatus from '../SendingStatus';

const Container = styled.div`
  width: 100%;
  height: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const Status = () => {
  const { id } = useParams();
  const privyToken = useSelector(selectPrivyToken);

  const { data, error, isLoading } = useGetGiftQuery(id, {
    skip: !id || !privyToken,
  });

  const gift = data?.gift;

  if (isLoading || !gift) {
    return <GiftSkeleton />;
  }

  if (error) {
    return (
      <WidthContainer>
        <Container>Error loading gift: {error.message}</Container>
      </WidthContainer>
    );
  }

  // Verify gift is in correct state
  if (gift.status !== 'SENT') {
    return (
      <WidthContainer>
        <Container>Invalid gift status</Container>
      </WidthContainer>
    );
  }

  return (
    <SendingStatus
      email={gift.receiver.email}
      token={gift.token}
      cardImage={gift.image}
      isSuccess={true}
      usdAmount={gift.baseTokenAmount}
      tokenAmount={gift.tokenAmount}
    />
  );
};

export default Status;
